import { MenuProps } from "antd"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { ROUTES } from "shared/constants/routesPaths"
import { familySelector } from "features/team/model/selectors/teamSelectors"
import { useTranslation } from "react-i18next"

import { logoutThunk } from "../model/slice/userSlice"

export const useUserMenuItems = (isPublicLink = false): MenuProps["items"] => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const familyData = useAppSelector(familySelector)
  const hasFamily = familyData?.owner_id
  const { t } = useTranslation()

  const items: MenuProps["items"] = []

  if (isPublicLink && hasFamily) {
    items.push(
      {
        key: "allAssets",
        label: t("a_sidebar_allAssets"),
        onClick: () => {
          navigate(ROUTES.dashboard.allAssets)
        }
      },
      { type: 'divider' as const }
    )
  }

  if (!isPublicLink || hasFamily) {
    items.push(
      {
        key: "userSettings",
        label: t("a_common_settings"),
        onClick: () => {
          navigate(ROUTES.profile.manageMembers)
        }
      },
      { type: 'divider' as const }
    )
  }

  items.push({
    key: "logout",
    label: t("a_common_logout"),
    onClick: () => {
      dispatch(logoutThunk())
      try {
        localStorage.removeItem("g_state")
        ;(window as any).google?.accounts.id.disableAutoSelect()
      } catch (e) {
        console.warn("Google logout cleanup failed", e)
      }
      setTimeout(() => {
        window.location.reload()
      }, 100)
    },
  })

  return items
}